(function() {
  function setCookie(key, value) {
    var expires = new Date();

    expires.setTime(expires.getTime() + (value * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/ ;expires=' + expires.toUTCString();
  }

  function deleteCookie(cname) {
    document.cookie = cname + '="";expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/';
    sessionStorage.removeItem('myApprovals');
  }

  $(document).ready(function() {
    var currentStoreId = $('#currentStoreId').val(),
        cookieVariable = currentStoreId + 'userSelectionCookie',
        categoryCode = $('.ph-headerparent__categorycode').text(),
        dataListName = 'data-list-name';

    if ($('.ph-decisionpage__card').attr(dataListName) === 'Category') {
      $('.ph-decisionpage__card').each(function() {
        $(this).attr(dataListName, 'Category_' + categoryCode);
      });
    }

    $(document).on('click', '.ph-signout__cookie', function() {
      deleteCookie(cookieVariable);
    });
    $(document).on('click', '.ph-customerselection__cookie', function() {
      deleteCookie(cookieVariable);
    });
    $('.ph-decisionpage__optionicon').click(function() {
      $('.ph-decisionpage-menutooltip').toggleClass('hidden');
    });
    $('#plp-viewtoggle').click(function() {
      $('.ph-decisionpage__cards').removeClass('ph-decisionpage__list ph-decisionpage__grid');
      deleteCookie(cookieVariable);

      var imageFlag = $('#viewimage').val();

      if ($('#viewmode').val() === 'grid') {
        $(this).find('.ph-result-view-icon').addClass('ph-result-grid-view').removeClass('ph-result-list-view');
        $('#viewmode').val('list');
        $('.ph-decisionpage__cards').addClass('ph-decisionpage__list');
        setCookie(cookieVariable, String('isUserSelectedColoum%3DTRUE%2CisUserSelectedImage%3D' + imageFlag));
      } else if ($('#viewmode').val() === 'list') {
        $(this).find('.ph-result-view-icon').addClass('ph-result-list-view').removeClass('ph-result-grid-view');
        $('#viewmode').val('grid');
        $('.ph-decisionpage__cards').addClass('ph-decisionpage__grid');
        setCookie(cookieVariable, String('isUserSelectedColoum%3DFALSE%2CisUserSelectedImage%3D' + imageFlag));
      }

      $('.ph-decisionpage-menutooltip').addClass('hidden');
    });

    $('#plp-imagetoggle').click(function() {
      $('.ph-decisionpage__cards').removeClass('ph-hideimage ph-showimage');
      deleteCookie(cookieVariable);
      $(this).parent().find('.ph-listlabel').removeClass('ph-icon-checkmark');

      var imageFlag = $('#viewimage').val(),
          viewmode = $('#viewmode').val(),
          viewFlag = '';

      if (viewmode === 'grid') {
        viewFlag = 'FALSE';
      } else {
        viewFlag = 'TRUE';
      }

      if ($('#viewimage').val() === 'FALSE') {
        $('#viewimage').val('TRUE');
        $('.ph-decisionpage__cards').addClass('ph-hideimage');

        imageFlag = $('#viewimage').val();

        setCookie(cookieVariable, String('isUserSelectedColoum%3D' + viewFlag + '%2CisUserSelectedImage%3D' + imageFlag));
      } else if ($('#viewimage').val() === 'TRUE') {
        $(this).parent().find('.ph-listlabel').addClass('ph-icon-checkmark');
        $('#viewimage').val('FALSE');

        imageFlag = $('#viewimage').val();

        $('.ph-decisionpage__cards').addClass('ph-showimage');
        setCookie(cookieVariable, String('isUserSelectedColoum%3D' + viewFlag + '%2CisUserSelectedImage%3D' + imageFlag));
      }

      $('.ph-decisionpage-menutooltip').addClass('hidden');
    });
    $('body,html').click(function(e) {
      if ($(e.target).closest('.ph-decisionpage__optionicon').length === 0 && $(e.target).closest('.ph-decisionpage-menutooltip').length === 0) {
        $('.ph-decisionpage-menutooltip').addClass('hidden');
      }
    });
  });
})();


